import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { OrganizationFacade } from '../../../common/facade/OrganizationFacade';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ReturnRequestExcelDto } from '../../../common/model/dto/ReturnRequestExcelDto';
import { ReturnRequestCorporateFacade } from '../../../common/facade/ReturnRequestCorporateFacade';
import { ReturnRequestCorporate } from '../../../common/model/ReturnRequestCorporate';
import { OperationalLogFacade } from '../../../common/facade/OperationalLogFacade';
import { OperationalModuleInfo } from '../../../common/model/dictionary/OperationalModuleInfo';
import { OperationalLog } from '../../../common/model/OperationalLog';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { ReturnRequestCorpDto } from '../../../common/model/dto/ReturnRequestCorpDto';
import { ReturnRequestCorporateDet } from '../../../common/model/ReturnRequestCorporateDet';
import { ReturnStoreCorporateFacade } from '../../../common/facade/ReturnStoreCorporateFacade';
import { ReturnStoreCorporateDet } from '../../../common/model/ReturnStoreCorporateDet';
import { ReturnReqCorpRejected } from '../../../common/model/ReturnReqCorpRejected';
import { Organization } from '../../../common/model/Organization';
import { ExcelUtility } from '../../../common/util/ExcelUtility';

// for excel import
type AOA = any[][];

interface returnParams {
  organizationId?: string,
  startDate: string,
  endDate: string,
  storeOriginId: number
};

@Component({
  selector: 'app-return-corporate',
  templateUrl: './return-corporate.component.html',
  styleUrls: ['./return-corporate.component.css']
})
export class ReturnCorporateComponent implements OnInit {

  currentDate = new Date();
  lblDownload = res.Download;

  public res = res;
  isSpanish = true;
  language = 0;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  generalAlerts = [];
  alertsFileExcel = [];

  fileNameUpload = '';

  // table
  rows : ReturnRequestCorporate[] = [];
  rowsOperationalLog : any[] = [];
  rowsRequested : ReturnRequestCorporateDet[] = [];
  rowsSent : ReturnStoreCorporateDet[] = [];
  rowsRejected : ReturnReqCorpRejected[] = [];
  private _filteredData: any[] = [];
  private _filteredDataLog: OperationalLog[] = [];
  private _filteredDataRequested: ReturnRequestCorporateDet[] = [];
  private _filteredDataSent: ReturnStoreCorporateDet[] = [];
  private _filteredDataRejected: ReturnReqCorpRejected[] = [];

  // filters
  storeOriginId = -1;
  storesOrigin = [];
  
  // import excel
  excelData: AOA = [ [], [] ];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';
  excelRows = [];
   
  // permissions
  hideStores = false;

  // modal
  @ViewChild('modalReturnRequest') modalReturnRequest: ModalDirective;
  // modalEventLog
  @ViewChild('modalEventLog') modalEventLog: ModalDirective;
  btnSaveDisabled: boolean = false;
  startDateLog = new Date();
  endDateLog = new Date();
  alertsLog = [];
  // modalRequested
  @ViewChild('modalRequested') modalRequested: ModalDirective;
  reqCode = ''
  alertsRequested = [];
  // modalSent
  @ViewChild('modalSent') modalSent: ModalDirective;
  alertsSent = [];
  // modalRejected
  @ViewChild('modalRejected') modalRejected: ModalDirective;
  alertsRejected = [];
  cmb_organization = '-1';

  configModal = {
    ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
  };

  datePickerPipe = 'DD/MM/YYYY';
  
  startDate = new Date();
  endDate = new Date();

  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  tenantId: number;
  organizations = [];
  organizationId = "-1";
  month = -1;
  txtReference = '';
  txtDate = new Date(); //Min Date
  txtMonthYear = new Date();
  txtMinDate = new Date();
  txtMaxDate = new Date();

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _facadeReturnReqCorp: ReturnRequestCorporateFacade,
    private _facadeReturnStoreCorporate: ReturnStoreCorporateFacade,
    private _facadeStore: StoreFacade,
    private _facadeOrganization: OrganizationFacade,
    private _facadeOperationalLog: OperationalLogFacade,
    public _datepipe: DatePipe,
    public strings: Strings,
    private localeService: BsLocaleService
  ) { }

  ngOnInit(): void {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.tenantId = this.strings.getTenant();
    this.lstOrganization = this.availableOrganizations.filter( item => item.tenantId == this.tenantId);

    this.datePickerPipe = this.isSpanish ? 'DD/MM/YYYY' : 'YYYY/MM/DD'

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }

    this.localeService.use(this.strings.getLanguage());
  }

  private getStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this.storesOrigin = [];
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.rows = []
        this._filteredData = []
        this.storeOriginId = -2
        this.loading = false;
        const lstStores = response.data;
        lstStores.forEach( store => {
          if (this.cmb_organization == store.organizationId) {
            this.storesOrigin.push(store);
          }
        });
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger');
      }
    );
  }

  public getReturnRequestCollection() {
    this.loading = true;
    if (this.startDate > this.endDate) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger', 'general');
      this.loading = false;
    }
    else if (this.storeOriginId == -2){
      this.addAlert(this.strings.GetText(res.AdviceSelectOptionStoreField), 'warning');
      this.loading = false;
    }
    else {
      let returnParams : returnParams = {
        organizationId: this.cmb_organization,
        startDate: this._datepipe.transform(this.startDate, 'yyyy-MM-ddTHH:mm:ss', 'local'),
        endDate: this._datepipe.transform(this.endDate, 'yyyy-MM-ddTHH:mm:ss', 'local'),
        storeOriginId: this.storeOriginId
      };
      this._facadeReturnReqCorp.GetCollection(returnParams).subscribe(
        response => {
          this.loading = false
          if(response.completed) {
            this.rows = response.data
            this._filteredData = response.data;
          }
        }, error => {
          this.loading = false;
          this.addAlert('<strong>¡Error!</strong> ' + error, 'danger', 'general');
        }
      );
    }
  }

  public getOperationalLog() {
    this.loading = true;
    this._facadeOperationalLog.GetByTypeDate(OperationalModuleInfo.ReturnReqCorpId, this.startDateLog, this.endDateLog).subscribe(
      response => {
        this.loading = false
        if(response.completed) {
          response.data.forEach(log => {
            log.tagLabel = log.catDetEntryTypeId == CatalogDetInfo.CatDetTypeLogError ? 'error' : log.catDetEntryTypeId == CatalogDetInfo.CatDetTypeLogsSuccess ? 'success' : 'warning';
          });
          this.rowsOperationalLog = response.data
          this._filteredDataLog = response.data;
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + error, 'danger', 'log');
      }
    );
  }

  public getReqDet(returnReqCorporateId: number) {
    this.loading = true;
    this._facadeReturnReqCorp.GetDetail(returnReqCorporateId).subscribe(
      response => {
        this.loading = false
        if(response.completed) {
          this.rowsRequested = response.data
          this._filteredDataRequested = response.data;
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + error, 'danger', 'requested');
      }
    );
  }

  public getReturnStoreDet(returnReqCorporateId: number) {
    this.loading = true;
    this._facadeReturnStoreCorporate.GetDetailByReqCorporateId(returnReqCorporateId).subscribe(
      response => {
        this.loading = false
        if(response.completed) {
          this.rowsSent = response.data
          this._filteredDataSent = response.data;
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + error, 'danger', 'sent');
      }
    );
  }

  public getReturnRejected(returnReqCorporateId: number) {
    this.loading = true;
    this._facadeReturnReqCorp.GetRejectedList(returnReqCorporateId).subscribe(
      response => {
        this.loading = false
        if(response.completed) {
          this.rowsRejected = response.data
          this._filteredDataRejected = response.data;
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + error, 'danger', 'rejected');
      }
    );
  }

  onChangeStartDate(value) {
    this.txtMinDate = this.subtractTimeFromDate(value, 6);
    this.txtMaxDate = this.txtMaxDate >= this.txtMinDate ? this.txtMaxDate : this.txtMinDate;
    //this.txtMaxDate = this.txtMaxDate > this.txtMinDate ? this.txtMaxDate : this.txtMinDate > this.txtMaxDate ? this.txtMinDate : this.txtMaxDate;
  }
  
  downloadLayout() {
    const link = document.createElement('a');
    if(this.isSpanish) {
      link.download = 'Layout_Devoluciones.xlsx';
    }
    else {
      link.download = 'Layout_Returns.xlsx';
    }
    link.href = 'assets/layout/Layout_Devoluciones.xlsx';
    link.click();
  }

  onChangeOrganization() {
    if(this.cmb_organization != "-1") {
      this.getStores();
    }
  }

  uploadExcel(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'excel');
      return;
    }
    // check file is valid
    if (!this.validateFile(target.files[0].name, 'xlsx')) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted), 'danger', 'excel');
      return;
    }

    this.fileNameUpload = event.target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.excelRows = [];
      this.excelData.forEach((element, index) => {
        if (index !== 0) {
          // this.lsInstruction.push(layoutInstruction)
          if (element.length > 0) {
            const data = new ReturnRequestExcelDto();

            data.storeOriginCode = element[0];
            data.styleVariety = element[1];
            data.sizeName = element[2];
            data.comment = element[3];
            data.requestQuantity = element[4];
            this.excelRows.push(data);
          }
        }
      });
    };

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;

    this.addAlert(this.strings.GetText(res.File) + target.files[0].name + ' ' + this.strings.GetText(res.UploadedCorrectly), 'success', 'excel');
  }

  validateExcel() {
    const data: ReturnRequestCorpDto = {
      id: 0,
      language: this.strings.getLanguage(),
      month: this.txtMonthYear.getMonth() + 1,
      year: this.txtMonthYear.getFullYear(),
      reference: this.txtReference,
      organizationId: this.organizationId.toString(),
      startDate: this._datepipe.transform(this.txtMinDate, 'yyyy-MM-ddTHH:mm:ss', 'local'),
      endDate: this._datepipe.transform(this.txtMaxDate, 'yyyy-MM-ddTHH:mm:ss', 'local'),
      detail: this.excelRows
    };

    this._facadeReturnReqCorp.CreateWithValidation(data).subscribe(
      response => {
        if (response.completed) {
          this.loading = false;
          this.btnSaveDisabled = true;
          this.addAlert('<strong>' + response.message + '</strong>', 'success', 'excel');
        }
        else {
          switch (response.data) {
            case -1:
              this.loading = false;
              this.addAlert('<strong>' + response.message + '</strong>', 'warning', 'excel');
              break;
            default:
              this.loading = false;
              this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');
              break;
          }
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'excel');
      }
    );
  }

  private validateFile(name: String, extension: String) {
    let ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext === 'xls') {
      ext = 'xlsx';
    }
    if (ext.toLowerCase() === extension) {
      return true;
    } else {
      return false;
    }
  }

  saveReturnRequest() {
    this.loading = true;
    if (this.returnRequestValid()) {
      this.validateExcel()
    } else {
      this.loading = false;
    }
  }

  private returnRequestValid() {
    let response = true;

    if (this.organizationId === "-1") {
      response = false;
      this.addAlert('<strong>' + this.strings.GetText(res.AlertYouMustFillTheFieldsOfTheForm) + '</strong>', 'warning', 'excel');
    }

    if (this.excelRows.length <= 0) {
      response = false;
      this.addAlert('<strong>' + this.strings.GetText(res.EmptyLayout) + '</strong>', 'warning', 'excel');
    }
    return response;
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String = null) {
    if (fileType === 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    }
    if (fileType === 'log') {
      this.alertsLog = [];
      this.alertsLog.push({
        type: type,
        msg: message
      });
    }
    if (fileType === 'requested') {
      this.alertsRequested = [];
      this.alertsRequested.push({
        type: type,
        msg: message
      });
    }
    if (fileType === 'sent') {
      this.alertsSent = [];
      this.alertsSent.push({
        type: type,
        msg: message
      });
    }
    if (fileType === 'rejected') {
      this.alertsRejected = [];
      this.alertsRejected.push({
        type: type,
        msg: message
      });
    }
    if (fileType === 'general' || fileType === null) {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
  }

  // Abrir modal para subir layout de solicitud de devoluciones
  openModal() {
    this.generalAlerts = [];
    this.alertsFileExcel = [];
    this.organizationId = "-1";
    this.txtMonthYear = new Date();
    this.txtReference = '';
    this.txtMinDate = new Date();
    this.txtMaxDate = new Date();
    this.excelRows = [];
    this.modalReturnRequest.show();
  }

  // Abrir modal para mostrar log de eventos
  openEventLogModal() {
    this.alertsLog = [];
    this.rowsOperationalLog = [];
    this.startDateLog = new Date();
    this.endDateLog = new Date();
    this.btnSaveDisabled = false;
    this.modalEventLog.show();
    this.getOperationalLog();
  }

  // Abrir modal para mostrar log de eventos
  openModalRequested(returnReqCorporateId: number, reqCode: string) {
    this.reqCode = reqCode;
    this.alertsRequested = [];
    this.rowsRequested = [];
    this.modalRequested.show();
    this.getReqDet(returnReqCorporateId);
  }

  // Abrir modal para mostrar devoluciones enviadas
  openModalSent(returnReqCorporateId: number, reqCode: string) {
    this.reqCode = reqCode;
    this.alertsSent = [];
    this.rowsSent = [];
    this.modalSent.show();
    this.getReturnStoreDet(returnReqCorporateId);
  }

  // Abrir modal para mostrar devoluciones rechazadas
  openModalRejected(returnReqCorporateId: number, reqCode: string) {
    this.reqCode = reqCode;
    this.alertsRejected = [];
    this.rowsRejected = [];
    this.modalRejected.show();
    this.getReturnRejected(returnReqCorporateId);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(item => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  updateFilterLog(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredDataLog[0]);
    // assign filtered matches to the active datatable
    this.rowsOperationalLog = this._filteredDataLog.filter(item => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  updateFilterRequested(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredDataRequested[0]);
    // assign filtered matches to the active datatable
    this.rowsRequested = this._filteredDataRequested.filter(item => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  updateFilterSent(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredDataSent[0]);
    // assign filtered matches to the active datatable
    this.rowsSent = this._filteredDataSent.filter(item => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  updateFilterRejected(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredDataRejected[0]);
    // assign filtered matches to the active datatable
    this.rowsRejected = this._filteredDataRejected.filter(item => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }

  downloadReport() {
    if (this.rows.length > 0) {
      this.loading = true;
      this.messageLoader = this.strings.GetText(res.Loading);
      
      const data: any = [];
      this.rows.forEach((row) => {
        const info = {
          [this.strings.GetText(res.RequestReference)]: row.code,
          [this.strings.GetText(res.RequiredDate)]: row.startDate,
          [this.strings.GetText(res.MaximiumDateRequired)]: row.endDate,
          [this.strings.GetText(res.OriginStore)]: row.storeName,
          [this.strings.GetText(res.ReferenceRequest)]: row.reference,
          [this.strings.GetText(res.Brand)]: row.brandName,
          [this.strings.GetText(res.Division)]: row.divisionName,
          [this.strings.GetText(res.Cedis)]: row.cedis,
          [this.strings.GetText(res.RequestedQuantity)]: row.totalRequestedQuantity,
          [this.strings.GetText(res.AmountSent)]: row.sentQuantity,
          [this.strings.GetText(res.RejectedQuantity)]: row.rejectedQuantity,
          [this.strings.GetText(res.Percentage)]: row.percentCompleted
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, "ReturnCorporate");
      this.loading = false;
    } else {
      this.addAlert(
        this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
        "warning");
      this.loading = false;
    }
  }
}
